<template>
  <div class="col">
    <p>이 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯("Web-widget")은 tobook.link s.r.o. (등록 번호 19608217), 법적 주소: Pavla Beneshe 750/8, Prague 19900에 의해 소유 및 운영됩니다.</p>
    <h6 class="mt-1 mb-1">
      주요 용어
    </h6>
    <ul>
      <li><b>사용자</b> - tobook.link 사이트 및 애플리케이션("서비스 제공자" 또는 "고객")의 모든 사용자를 의미합니다.</li>
      <li><b>서비스 제공자</b> - 등록된 사용자인 경우, tobook.link 예약 페이지를 통해 판매를 위한 상품 및 서비스를 제공하는 당신입니다.</li>
      <li><b>고객</b> - 서비스 제공자가 제공하는 서비스를 예약하고 등록된 사용자가 아닌 경우, 당신입니다.</li>
      <li><b>결제 제공자</b> - 서비스 제공자의 서비스에 대한 결제를 처리하는 결제 시스템을 의미합니다.</li>
      <li><b>거래 수수료</b> - 이체 금액에 부과되는 비율입니다. 세부 사항은 <b-link :to="{name: 'pricing'}">약관</b-link> 섹션에서 찾을 수 있습니다.</li>
      <li><b>서비스 수수료</b> - 고객이 tobook.link 예약 시스템을 사용하는 데 부과되는 고정 금액입니다. 자세한 내용은 <b-link :to="{name: 'pricing'}">약관</b-link> 섹션에서 제공됩니다.</li>
    </ul>
    <p>현재 약관("약관")은 당신(“고객” 또는 “서비스 제공자”, “당신”)과 우리 사이의 법적으로 구속력 있는 계약("계약")을 구성하며, tobook.link에 대한 접근 및 사용뿐만 아니라 제품 또는 서비스("서비스")의 구매에서 비롯된 법적 관계를 규율합니다. 이 약관을 주의 깊게 읽으십시오. tobook.link를 설치, 사용, 등록 또는 접근함으로써, 당신은 이 모든 약관을 준수하는 데 명시적으로 동의합니다.</p>
    <p>이 약관의 사본을 인쇄하거나 저장하는 것이 좋습니다. 약관의 업데이트된 버전은 항상 tobook.link 애플리케이션 내에서 사용할 수 있습니다. 약관의 마지막 수정 날짜는 위에 명시되어 있습니다.</p>
    <p>tobook.link 애플리케이션에 등록되지 않은 개인은 애플리케이션 내에서 사용 가능한 특정 기능을 보고 사용할 수 있지만, 애플리케이션의 일부 기능을 사용할 수 없습니다.</p>
    <h6 class="mt-5 mb-3">
      1. 서비스의 일반적 설명
    </h6>
    <p>1.1. tobook.link 웹사이트, 모바일 애플리케이션 및 웹 위젯은 고객이 원하는 서비스 제공자("서비스 제공자")로부터 특정 서비스를 예약할 수 있는 전자 예약 시스템입니다. 가능한 서비스 유형은 무제한이며 지속적으로 확장되고 있습니다.</p>
    <p>1.2. 예약 시스템의 제공자로서, 우리는 tobook.link 애플리케이션에 나열된 어떠한 서비스도 제공, 제어, 제공, 소유하지 않습니다. 클라이언트가 서비스를 주문하고 서비스 제공자가 예약된 서비스를 확인하면("tobook.link"), 양 당사자는 서로 계약을 체결하며 tobook.link는 이 계약의 당사자로 간주되지 않습니다("계약"). 마찬가지로, tobook.link는 서비스 제공자와 고객 간의 계약 관계의 당사자가 아닙니다.</p>
    <h6 class="mt-5 mb-3">
      2. 이용 약관
    </h6>
    <p>2.1. 웹사이트, 모바일 애플리케이션("tobook.link")의 사용 및 등록(계정 생성)은 무료입니다.</p>
    <p>2.2. 당신은 고객으로서 등록 없이 웹사이트("tobook.link")에 접근하고 사용할 수 있습니다. 그러나 서비스 제공자가 되고자 하는 경우, 등록 절차를 거쳐 계정을 만들어야 합니다.</p>
    <p>2.3. 18세 이상의 개인은 tobook.link에 계정을 등록할 수 있습니다.</p>
    <p>2.4. 등록 시, 당신은 당신 자신에 대한 정확하고 진실하며 정확한 정보를 제공하고 변경 사항이 있을 때마다 이를 업데이트해야 합니다. 제공해야 하는 데이터에 대한 보다 자세한 정보는 우리의 개인정보 보호정책을 참조하십시오.</p>
    <p>2.5. 계정의 등록 및 인증은 당신의 전화번호와 이메일 주소를 사용하여 발생합니다.</p>
    <p>2.6. 서비스 제공자는 자신의 로그인 세부 정보를 공개해서는 안 되며, 세부 정보를 보관하고 세부 정보가 자신만 알고 사용하도록 해야 하며, 다른 개인이 이러한 세부 정보에 접근하거나 사용하도록 허용해서는 안 됩니다. 로그인 세부 정보가 분실, 도난당했거나 다른 방법으로 남용되었다고 의심할 만한 이유가 있거나 제3자가 접근할 수 있다고 의심되는 경우 즉시 우리에게 알리십시오. 사용자의 식별 코드를 사용하여 수행된 모든 작업은 사용자에 의해 수행된 것으로 간주되며, 사용자는 이러한 작업의 결과로 발생하는 모든 결과에 대한 전적인 책임을 집니다.</p>
    <h6 class="mt-5 mb-3">
      3. 예약 서비스
    </h6>
    <p>3.1. 예약하기 전에, 고객은 서비스가 자신의 필요를 충족하는지 확인해야 합니다.</p>
    <p>3.2. 고객은 애플리케이션에서 제공된 연락처 정보를 사용하여 서비스 제공자에게 연락할 수 있습니다.</p>
    <p>3.3. 서비스를 예약할 때, 날짜 및 시간 예약 요청이 서비스 제공자에게 전송됩니다. 고객은 예약을 확인하는 이메일 또는 메시지를 받아야 합니다.</p>
    <p>3.4. 현재 예약 정보는 서비스 제공자의 개인 계정에서 사용할 수 있습니다.</p>
    <h6 class="mt-5 mb-3">
      4. 서비스 제공자의 서비스에 대한 지불
    </h6>
    <p>4.1. 결제 제공자</p>
    <ul>
      <li>tobook.link는 제3자 결제 제공자(이하 "결제 제공자"라 함)를 사용하여 결제 제공자 시스템 내 서비스 제공자의 개인 계정으로 직접 결제를 처리합니다. tobook.link는 결제 제공자의 서비스의 가용성 및 보안을 보장하기 위해 합리적인 주의를 기울이지만, 결제 제공자의 서비스에 대한 중단없는 또는 지속적인 접근을 보장할 수 없으며, 결제 제공자가 바이러스 또는 오류로부터 자유로울 것이라는 것을 보장할 수 없습니다.</li>
    </ul>
    <p>4.2. 책임</p>
    <ul>
      <li>서비스 제공자는 결제 제공자를 통해 자신의 서비스에 대해 지불할 때 고객의 권리를 유지할 책임이 전적으로 있습니다.</li>
      <li>결제 또는 보증금 수집이 서비스 제공자의 서비스가 제공되는 국가의 법에 위반되는 경우, 서비스 제공자는 자신의 예약 페이지에서 결제 또는 보증금 기능을 사용하지 않도록 해야 합니다. 그렇지 않으면, 서비스 제공자는 전적인 책임을 집니다.</li>
      <li>tobook.link는 결제 제공자가 저지른 오류에 대해 책임을 지지 않습니다. 결제 처리에 대한 접근은 수리, 유지 보수 또는 새로운 장비 또는 서비스의 도입을 위해 때때로 제한될 수 있습니다. 우리는 계획된 중단에 대해 합리적인 통지를 제공하려고 노력할 것이며, 가능한 한 빨리 시설의 운영을 복구하기 위해 모든 노력을 기울일 것입니다.</li>
      <li>서비스 제공자는 서비스의 총 비용에 대한 간접 세금(예: 판매세, VAT, GST 또는 서비스 세) 및 추가 상품 또는 서비스 판매 또는 할인에 대한 조정에 대해 단독으로 지불 책임이 있습니다.</li>
    </ul>
    <p>4.3. 서비스 제공자가 설정한 가격</p>
    <ul>
      <li>가격 및 수수료는 결제 제공자의 결제 페이지에 표시됩니다.</li>
      <li>고객이 서비스 제공자로부터 서비스 제공 중에 구매한 추가 상품 또는 서비스를 반영하여 고객이 지불하는 최종 가격이 조정될 수 있습니다.</li>
      <li>tobook.link는 고객에게 서비스 수수료를 포함하며, 이는 지불해야 할 최종 금액에 반영됩니다.</li>
    </ul>
    <p>4.4. 서비스 제공자의 서비스에 대한 지불</p>
    <ul>
      <li>tobook.link는 서비스 제공자를 대신하여 결제를 수집하지 않으며, 서비스에 대한 지불은 고객이 서비스 제공자에게 직접 지불하는 것으로 간주됩니다. 지불 처리 수수료를 제외하고, 서비스 제공자는 고객이 결정한 지불의 100%를 받게 됩니다.</li>
      <li>고객은 최종 가격에 명시된 통화로 서비스에 대해 지불합니다. 고객이 부담하는 화폐 전환 비용 또는 기타 비용은 지불 외에 고객의 책임입니다.</li>
    </ul>
    <p>4.5. 세금</p>
    <ul>
      <li>tobook.link는 서비스 제공자의 서비스 제공자가 서비스를 제공하기 때문에 서비스 제공자에 대한 세금을 부과하지 않습니다. 고객이 결제 제공자를 통해 결제를 하는 경우, 결제 제공자는 고객의 이메일로 송장을 제공할 것입니다.</li>
    </ul>
    <p>4.6. 예약 전송</p>
    <ul>
      <li>고객이 확인을 받은 후 예약(예: 시간/날짜)을 부분적으로 또는 완전히 전송하고자 하는 경우, 고객은 관련 서비스 제공자에게 직접 연락할 수 있습니다.</li>
      <li>고객은 서비스 제공자가 명시한 특정 기간 내에 예약되지 않은 시간에만 예약을 전송할 수 있습니다. 고객이 예약을 전송할 수 있는 시간과 예약의 예정된 시작 시간 사이의 간격은 각 서비스 제공자가 독립적으로 결정하고 서비스 제공자에게 첫 번째 요청 시 고객에게 알려줍니다. 고객은 예약을 확인하기 전에 취소 정책을 숙지하고 이해해야 합니다. 예약을 전송할 수 있는 기능은 전송을 원하는 시간에 서비스 제공자의 가용성에 따라 달라집니다.</li>
    </ul>
    <p>4.7. 취소 정책, 불참</p>
    <ul>
      <li>법적 권리 외에도, 특정 상황 하에서 고객은 예상치 못한 상황 또는 비상 상황으로 인해 서비스 제공자와의 예약을 취소할 권리가 있습니다. 예약을 취소하려면 고객은 서비스 제공자에게 직접 연락해야 합니다.</li>
      <li>서비스 제공자는 비상 상황, 예상치 못한 상황 또는 서비스 제공자의 정책에 명시된 기타 유효한 이유로 일방적으로 예약을 취소할 수도 있습니다.</li>
    </ul>
    <p>4.8. 보증금 및 예약 취소</p>
    <ul>
      <li>서비스 제공자는 예약을 확인하기 위해 서비스 비용의 0%에서 100%까지의 보증금을 요청할 수 있습니다. 예약 절차를 완료하기 전에 서비스 제공자의 계약을 직접 요청하여 숙지하는 것이 좋습니다. 보증금은 환불되지 않을 수 있습니다. tobook.link는 서비스 제공자에게 지급된 보증금에 대해 책임을 지지 않습니다.</li>
      <li>고객이 예약을 취소하는 경우, 보증금 환불 문제는 서비스 제공자의 취소 정책에 따라 서비스 제공자와 직접 해결해야 합니다.</li>
      <li>서비스 제공자가 예약을 취소하는 경우, 그들은 고객의 보증금을 환불해야 합니다. 환불이 이루어지지 않는 경우, 고객은 문제를 해결하기 위해 관련 법 집행 기관에 연락할 권리가 있습니다. 고객은 또한 support@tobook.link로 해당 사건을 우리에게 알려 해당 서비스 제공자의 예약 페이지를 차단할 수 있는 조치를 취할 수 있습니다.</li>
      <li>고객에게 보증금을 환불하는 것은 서비스 제공자와의 합의에 따라 이루어지며, 거래 수수료와 서비스 수수료는 포함되지 않습니다.</li>
    </ul>
    <p>4.9. 취소 및 불참</p>
    <ul>
      <li>예약을 취소하려면 고객은 서비스 제공자에게 직접 연락해야 합니다. 고객이 예약 시작 전에 예약을 취소할 수 있는 시간 간격은 각 서비스 제공자가 개별적으로 결정합니다.</li>
      <li>tobook.link는 고객이 예약을 확인하기 전에 관련 서비스 제공자에게 직접 연락하여 취소 정책을 요청할 것을 권장합니다.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      5. 리뷰 및 평가
    </h6>
    <p>5.1. 서비스를 받은 후, 고객은 서비스 제공자에 대한 리뷰를 남기고 평가를 제공할 수 있습니다.</p>
    <p>5.2. 리뷰와 평가는 진실해야 하며, 거칠고/또는 외설적인 표현을 포함해서는 안 됩니다.</p>
    <h6 class="mt-5 mb-3">
      6. 고객과 서비스 제공자 간의 분쟁
    </h6>
    <p>6.1. 제공된 서비스가 서비스의 설명과 완전히 일치하지 않는 경우, 고객은 서비스 제공자에게 처음에는 무료로 서비스를 제공하여 주문한 서비스와 그 설명과 일치하도록 요구할 권리가 있습니다.</p>
    <p>6.2. 예약 시점에 고객이 서비스가 자신의 필요를 충족하지 않는다는 것을 알고 있었거나 알 수 없었다면, 서비스가 설명과 일치하지 않는다고 간주되지 않습니다. 또한 서비스를 받기 위해 고객이 제공해야 하는 불완전한 자료가 비일치의 이유이거나, 고객이 서비스를 받을 준비가 되어 있지 않거나, 서비스를 받기 위한 기타 예비 조건을 충족하지 않았거나, 이를 서비스 제공자에게 미리 연락하여 알리지 않은 경우에도 마찬가지입니다.</p>
    <p>6.3. 서비스 제공으로 인해 고객의 건강 및/또는 재산에 해를 입힌 경우, 고객은 해당 서비스로 인해 발생한 손해에 대한 배상을 청구하기 위해 법원에 소를 제기할 권리가 있습니다.</p>
    <p>6.4. 분쟁된 문제에 대해 고객과 서비스 제공자 간에 합의에 이르지 못하는 경우, 고객은 분쟁을 해결하기 위해 소비자 권리 보호 센터에 연락할 권리가 있습니다.</p>
    <p>6.5. 고객 또는 서비스 제공자가 소비자 권리 보호 센터의 결정에 동의하지 않는 경우, 당사자는 법규에 따라 분쟁이 해결될 법원에 소를 제기할 권리가 있습니다.</p>
    <p>6.6. 유럽 위원회는 대체 분쟁 해결(ADR)을 위한 플랫폼을 제공하며, 해당 플랫폼은 http://ec.europa.eu/odr에서 이용할 수 있습니다.</p>
    <h6 class="mt-5 mb-3">
      7. 책임 및 면책 조항
    </h6>
    <p>7.1. 당신은 사이트 및 우리와 관련된 모든 애플리케이션의 사용에 대한 전적인 책임을 집니다. 사이트 또는 어떠한 콘텐츠에 대한 불만족에 대한 유일한 구제책은 사이트 또는 해당 콘텐츠 사용을 중단하는 것입니다. 이러한 구제의 제한은 당사자 간의 합의의 일부입니다.</p>
    <p>7.2. tobook.link는 사이트 또는 어떠한 콘텐츠, 서비스 또는 사이트의 기능이 오류가 없거나 중단되지 않을 것이라고 약속하지 않으며, 결함이 수정될 것이라고 약속하지 않으며, 사이트 사용이 특정 결과를 제공할 것이라고 약속하지 않습니다. 사이트와 그 콘텐츠는 "있는 그대로" 및 "사용 가능한 대로" 제공됩니다.</p>
    <p>7.3. 어떠한 경우에도 tobook.link는 당신에게 간접적, 결과적, 예시적, 우발적 또는 징벌적 손해, 포함하여 손실된 이익에 대해 책임을 지지 않으며, tobook.link가 그러한 손해의 가능성을 통보받았더라도 마찬가지입니다.</p>
    <p>7.4. 이용 약관의 다른 규정에도 불구하고, tobook.link가 당신에게 어떤 손해나 손실에 대해 책임이 있다고 결정되는 경우, tobook.link의 책임은 어떤 경우에도 (1) 최초의 청구가 제기된 날짜 이전 6개월 동안 사이트의 어떤 서비스 또는 기능과 관련하여 지불된 모든 구독 또는 유사한 수수료의 총액을 초과하지 않습니다.</p>
    <p>7.5. tobook.link는 화재, 홍수, 전쟁, 내란, 파업, 락아웃, 자연 재해, 전력 실패, 컴퓨터 바이러스 또는 tobook.link의 통제를 벗어난 다른 사건으로 인해 우리의 의무를 수행하거나 적시에 수행하지 못하는 데 대해 책임을 지지 않습니다.</p>
    <p>7.6. tobook.link는 서비스 제공자의 서비스의 품질, 안전성 또는 적합성을 통제하지 않으며, 서비스, 평가 설명, 진실성 또는 정확성 또는 기타 관련 정보의 정확성을 보장하지 않습니다. 우리는 서비스 제공자가 등록한 서비스, 포함하여 그 품질 및 준수 여부를 확인하지 않습니다. 서비스 제공자의 평가, 리뷰 또는 기타 관련 정보는 tobook.link의 서비스의 품질 또는 준수에 대한 표현이나 보증이 아닙니다. tobook.link는 서비스의 전자 예약만 제공하므로 서비스 제공자를 선택할 때 모든 정보를 주의 깊게 확인하십시오.</p>
    <p>7.7. 법률이 허용하는 최대한의 범위 내에서, 당신은 tobook.link, 그 직원들 및 자회사를 모든 청구, 책임, 손해 및 비용(법원 비용 포함)으로부터 방어, 면책 및 보호해야 하며, 이는 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯 또는 그 사용에 대한 사용자의 접근과 관련하여 발생하거나 어떤 식으로든 관련된 경우에 적용됩니다.</p>
    <p>7.8 tobook.link는 모든 보증을 부인합니다, 명시적이거나 묵시적이든, 정확성, 비침해, 상품성 및 특정 목적에의 적합성을 포함한 모든 보증을 부인합니다.</p>
    <p>7.8.1 tobook.link는 사이트에서 다운로드된 어떤 파일도 바이러스, 오염 또는 파괴적 기능이 없다는 것을 보장할 수 없습니다.</p>
    <p>7.9 tobook.link는 사이트의 사용 및/또는 tobook.link 서비스와 관련하여 제3자의 행위, 누락 및 행동에 대해 어떠한 책임도 부인합니다.</p>
    <h6 class="mt-5 mb-3">
      8. 적용 법률 및 분쟁 해결
    </h6>
    <p>8.1. 소비자 보호 규정의 의무적 적용에 편견 없이, 이 약관은 체코 공화국의 법률에 의해 규제됩니다.</p>
    <p>8.2. 계약의 규정으로 인해 사용자와 tobook.link 사이에 분쟁이 발생하는 경우, 사용자는 자신의 이름과 연락처 정보, 불만 제출 날짜 및 이유를 명시하여 우리에게 서면 또는 전자적으로 불만을 제출할 권리가 있습니다. 우리는 불만에 대해 15일 이내에 회신할 것입니다.</p>
    <p>8.3. 분쟁이 협상을 통해 해결되지 않는 경우, 당사자는 체코 공화국의 법률에 따라 체코 공화국의 법원에 분쟁을 회부할 수 있습니다.</p>
    <h6 class="mt-5 mb-3">
      9. 지적 재산권
    </h6>
    <p>9.1. 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯 콘텐츠, 포함되지만 이에 국한되지 않는 이미지, 비디오, 로고, 메뉴, 웹사이트, 그래픽, 색상, 도구, 디자인, 방법, 기능 및 앱 작동을 지원하는 모든 소프트웨어는 저작권 및 기타 모든 지적 재산권으로 보호됩니다. 콘텐츠의 전체 또는 일부의 재생산, 그리고 어떤 종류의 재생산도 금지됩니다.</p>
    <p>9.2. 사용자는 앱과 그 콘텐츠를 보는 것만 허용됩니다. 사용자는 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯 및 그 콘텐츠를 보는 데 필수적인 일시적인 성격을 가지며 일시적인 복제 활동만 수행할 수 있습니다. 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯에 게시된 모든 저작물의 저자는 자신의 작업의 저작권을 주장할 권리가 있으며, 그 작업의 왜곡 또는 기타 수정을 포함하여 명예 또는 평판을 손상시킬 수 있는 작업에 이의를 제기할 권리가 있습니다.</p>
    <p>9.3. 앱에서 구매할 서비스를 구분하는 모든 상표는 각각의 소유자의 등록 상표이며 앱에서 서비스를 설명하고 광고하는 데 사용됩니다. 우리와 모든 다른 등록된 상표 소유자는 우리가 소유한 상표를 사용할 독점적 권리를 가지고 있습니다. 그러한 상표의 불법적 또는 무단 사용은 금지되며 심각한 법적 결과를 초래할 수 있습니다.</p>
    <p>9.4. 공개적으로 이용 가능한 웹 페이지에서 앱의 콘텐츠에 대한 링크를 사용하는 데 관심이 있는 경우 아래 이메일 주소로 저희에게 연락하십시오: support@tobook.link.</p>
    <h6 class="mt-5 mb-3">
      10. 계약의 유효성 및 종료
    </h6>
    <p>10.1. 이 계약은 종료될 때까지 유효합니다.</p>
    <p>10.2. 사용자는 언제든지 앱에서 자신의 등록을 종료함으로써(자신의 계정을 삭제함으로써) 계약을 종료할 수 있으며, 앱에 대한 사용 및 접근을 종료하고 자신의 장치에서 삭제함으로써 계약을 종료할 수 있습니다. GDPR에 따라, 사용자는 삭제라고도 하는 '잊혀질 권리'를 가지며, 이는 귀하의 요청에 따라 우리가 수집한 귀하의 모든 개인 데이터를 삭제할 것임을 의미합니다.</p>
    <p>10.3. 사용자가 계약을 종료하는 경우, 모든 현재 서비스 예약은 자동으로 취소되며 예약 취소 조항(예약 취소 및 환불 조항)에 따라 환불됩니다.</p>
    <p>10.4. 다음과 같은 상황과 전제 조건은 tobook.link가 사용자의 tobook.link에 대한 접근을 제한, 중단 또는 거부할 충분한 이유를 제공합니다(심각하거나 반복적인 금지된 행위의 경우 일시적 또는 영구적으로):</p>
    <ul>
      <li>법적 요구 사항.</li>
      <li>사용자가 적용 가능한 법률을 위반한다고 믿을 만한 이유.</li>
      <li>약관의 어떤 요구 사항의 위반.</li>
      <li>사용자에 대한 불만, 예약의 반복적 취소.</li>
      <li>개인의 사회적 가치와 주관적 권리를 보호할 필요성.</li>
      <li>사용자의 지속적인 앱 사용이 앱 또는 제3자의 보안에 위협이 된다고 믿을 만한 이유.</li>
      <li>사기 또는 기타 불법 활동을 방지하기 위함입니다.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      11. 최종 조항
    </h6>
    <p>11.1. tobook.link는 특히 적용 가능한 법률 및 규정의 변경으로 인해 언제든지 약관을 변경할 권리를 보유합니다. 약관의 마지막 수정 날짜는 위에 표시되어 있습니다. 변경된 약관을 거부하고 계약을 즉시 종료함으로써 계약을 종료할 수 있습니다(계정을 삭제하고 앱에 대한 사용 및 접근을 종료함). 이 경우, 이전 버전의 약관에 대한 귀하의 동의는 유효하게 유지되며 귀하와 우리 사이의 분쟁에 적용됩니다. 웹사이트, 모바일 애플리케이션("tobook.link") 및 웹 위젯 및 그 서비스에 계속 접근하거나 사용함으로써 귀하는 약관의 변경에 동의합니다.</p>
    <p>11.2. 우리의 견해로는 약관의 변경이 중요하다면, tobook.link는 변경 사항이 발효되기 1(하나) 달력 월 전에 사용자에게 통지할 것입니다. 위의 규정에도 불구하고, (i) 사용자에게 더 유리한; (ii) 법률에 의해 요구되는; (iii) 새로운 서비스의 추가 또는 기존 서비스의 추가 기능을 포함하는; 또는 (iv) 사용자의 권리를 줄이거나 사용자의 책임을 증가시키지 않는 변경 사항은 변경 사항의 통지에서 명시된 경우 즉시 발효됩니다.</p>
    <h6 class="mt-5 mb-3">
      12. 고객 지원 서비스 및 연락처
    </h6>
    <p>12.1. 모든 질문은
      <b-link
        :to="{name: 'partners'}"
      >tobook.link</b-link>에 '도움 받기' 섹션의 연락처 옵션을 통해 보낼 수 있습니다.</p>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'EnTermsOfUse',
  components: {
    BLink,
  },
}
</script>

<style scoped>

</style>
